/**
 * Build a usable image/file URL from whatever the backend returns.
 *
 * - empty            -> ''
 * - blob:/data: URIs -> returned as-is (local file previews)
 * - absolute http(s) -> returned as-is (e.g. the Inventory media URLs the
 *                       product/category/brand views already return in full)
 * - relative path    -> prefixed with our API origin (REACT_APP_API_URL
 *                       without the trailing /api), e.g. "uploads/chat/x.jpg"
 *                       -> "https://api.yellego.com/uploads/chat/x.jpg"
 *
 * Base URL comes from the admin .env (REACT_APP_API_URL), so it stays correct
 * across local/prod without touching code.
 */
const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api')
  .replace(/\/api\/?$/, '');

export function getImageUrl(path) {
  if (!path) return '';
  const value = String(path).trim();
  if (!value) return '';
  if (/^(blob:|data:)/i.test(value)) return value;      // local preview / inline
  if (/^https?:\/\//i.test(value)) return value;          // already absolute
  const clean = value.replace(/^\/+/, '');                // strip leading slashes
  return `${API_ORIGIN}/${clean}`;
}

export default getImageUrl;
